import React, { useContext, useRef, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { HeaderContext } from '@contexts/HeaderContext';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { UMDataContext } from '../../../contexts/UMDataContext';
import SiteMapping from '../../../configs/siteMapping';

const UMModal = () => {
    const firstParagraphText = useRef(null);
    const [state, dispatch] = useContext(HeaderContext);
    const { isShowUMPopup } = state;
    const [umData] = useContext(UMDataContext);
    const { t } = useTranslation();
    const { siteName } = useSiteInfo();
    const ClassNameMapping = {
        [SiteMapping.Nova88]: 'text-primary',
        [SiteMapping.IBCBet]: 'text-primary',
        [SiteMapping.PICA88]: 'text-primary',
        [SiteMapping.bong88]: 'text-highlight',
        [SiteMapping.viva88]: 'text-highlight',
        [SiteMapping.id8899]: 'text-primary',
        [SiteMapping.bettha88]: 'text-primary', // bettha(7a5555)
        [SiteMapping.taraPlays]: 'text-primary', // taraPlays(777777)
        [SiteMapping.fifabet]: 'text-primary',
        [SiteMapping.ocean99]: 'text-primary',
    };

    const closeUMPopup = () => {
        dispatch({ type: 'SHOW_UM_POPUP' });
    };

    useEffect(() => {
        if (firstParagraphText.current && umData.umPlatform) {
            const classNameBySite = ClassNameMapping[siteName];
            const deviceText = `<span class='${classNameBySite}'>${t(`lbl_login_${umData.umPlatform}`)}</span>`;
            const content = `${t('lbl_UMmsg_Txt1_1').replace('{0}', deviceText)}`;
            firstParagraphText.current.innerHTML = content;
        }
    }, [umData.umPlatform, umData.displayUmStartTime, umData.displayUmEndTime]);

    return (
        <div className="modal modal--um " data-open={isShowUMPopup} onClick={() => closeUMPopup()}>
            <div className="modal__dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal__close" onClick={() => closeUMPopup()}>
                    <a className="btn btn--icon">
                        <i className="icon icon--close" />
                    </a>
                </div>
                <div className="modal__header">
                    <span className="text">{t('lbl_UMmsg_Title')}</span>
                </div>
                <div className="modal__body">
                    <p>
                        <span className="text" ref={firstParagraphText} />
                        <br />
                        <span className="text-group">
                            <span className="text-col">
                                <span className="text-from">{t('lbl_UMmsg_Txt2_1')}</span>
                                <span className="text-to">{t('lbl_UMmsg_Txt2_2')}</span>
                            </span>
                            <span className="text-col">
                                <span className="text-highlight">{umData.displayUmStartTime}</span>
                                <span className="text-highlight">{umData.displayUmEndTime}</span>
                            </span>
                            <span className="text-gmt">(GMT+8)</span>
                        </span>
                        <br />
                        <span className="text">{t('lbl_UMmsg_Txt3')}</span>
                    </p>
                    <p><strong>{t('lbl_UMmsg_Txt4')}</strong></p>
                </div>
            </div>
        </div>
    );
};

export default UMModal;
